const STORAGE_KEY = 'novabotx_recent_apps';
const MAX_RECENT = 6;

export function loadRecentApps() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function rememberRecentApp(appId) {
  if (!appId) return loadRecentApps();
  const next = [appId, ...loadRecentApps().filter((id) => id !== appId)].slice(0, MAX_RECENT);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
  return next;
}
